import { ErrorMessage } from "@hookform/error-message";
import { Grid, Typography } from "@material-ui/core";
import MDEditor from '@uiw/react-md-editor';
import React from 'react';
import { Controller } from "react-hook-form";
import Collapsible from "./Collapsible/Collapsible";
import CheckboxInput from "./Inputs/CheckboxInput";
import FileInput from "./Inputs/FileInput";
import RadioInput from "./Inputs/RadioInput";
import SelectBox from './Inputs/SelectBox';
import TextBox from "./Inputs/TextBox";
import Text from "./Text";

export const TextController = ({ formObj, classes, control, eachWidth, ...props }) => {
    return (
        <Grid
            key={formObj.name}
            className={classes.gridItem}
            item
            xs={12}
            sm={formObj.eachWidth || eachWidth}
        >
            <Controller
                render={
                    ({ onChange, value, ref }) => (
                        <TextBox
                            onChange={e => onChange(e.target.value)}
                            name={formObj.name}
                            multiline={formObj.multiline}
                            id={formObj.name}
                            label={formObj.validationRules && formObj.validationRules.required
                                ? (formObj.label?.concat(" *")) : formObj.label}
                            type={formObj.type}
                            readOnly={formObj.readOnly}
                            value={value}
                        // inputRef={ref}
                        />
                    )
                }
                control={control}
                name={formObj.name}
                rules={{ ...formObj.validationRules }}
                defaultValue=''
            />
            <ErrorMessage
                as={<Text ascent="error" component="small" variant="body2" />}
                name={formObj.name}
            />
        </Grid>
    )
}

export const CheckboxController = ({ formObj, classes, control, eachWidth, ...props }) => {
    return (
        <Grid
            key={formObj.name}
            className={classes.gridItem}
            item
            xs={12}
            sm={formObj.eachWidth || eachWidth}
        // onClick={toggleCheck}

        >
            <Controller
                render={
                    ({ onChange, value, ref }) => (
                        <CheckboxInput
                            onChange={(e) => {
                                !formObj.readOnly && onChange((
                                    e.target.checked ? '1' : '0'
                                ))
                            }}
                            name={formObj.name}
                            label={formObj.validationRules && formObj.validationRules.required
                                ? (formObj.label?.concat(" *")) : formObj.label}
                            readOnly={formObj.readOnly}
                            isChecked={value == '1'}
                        />
                    )
                }
                control={control}
                name={formObj.name}
                rules={{ ...formObj.validationRules }}
                defaultValue={formObj.isChecked ? '1' : '0'}
            />
            <ErrorMessage
                as={<Text ascent="error" component="small" variant="body2" />}
                name={formObj.name}
            />
        </Grid>
    )
}

export const SelectController = ({ formObj, classes, control, eachWidth, ...props }) => {
    return (
        <Grid
            key={formObj.name}
            className={classes.gridItem}
            item
            xs={12}
            sm={formObj.eachWidth || eachWidth}
        >
            <Controller
                as={
                    <SelectBox
                        name={formObj.name}
                        id={formObj.name}
                        label={formObj.validationRules && formObj.validationRules.required
                            ? (formObj.label?.concat(" *")) : formObj.label}
                        options={formObj.options}
                        readOnly={formObj.readOnly}
                        {...formObj.props}
                    />
                }
                control={control}
                name={formObj.name}
                key={formObj.name}
                rules={{ ...formObj.validationRules }}
                defaultValue={formObj.props && formObj.props.multiple ? [] : ''}
                {...props}
            />
            <ErrorMessage
                as={<Text ascent="error" component="small" variant="body2" />}
                name={formObj.name}
            />
        </Grid>
    )
}


export const FileController = ({
    formObj = {},
    classes,
    control,
    eachWidth,
    fileType,
    collapsible = {
        wrapInCollapsible: false,
        collapsibleIsOpen: false
    },
    previewUrl = '',
    ...props
}) => {

    const renderController = () => (
        <Controller
            defaultValue={""}
            //old buggy line -> render={({ onChange, name, value }, { isTouched }) => (
            render={({ onChange, name, value }) => {
                return (
                    <FileInput
                        fileType={fileType}
                        onChange={(e) => {
                            console.log('e', e.target.files);
                            onChange(e.target.files)
                        }}
                        name={name}
                        buttonLabel={formObj.label}
                        previewUrl={null}
                        onClick={(e) => {
                            onChange([]);
                            e.target.value = null;
                        }}
                        imageName={value && value.length > 0 && value[0].name}
                        accept={formObj.accept}
                        readOnly={formObj.disableAccept}
                    />
                )
            }}
            control={control}
            name={formObj.name}
        />
    )

    return (
        <Grid
            key={formObj.name}
            className={classes.gridItem}
            item
            xs={12}
            sm={formObj.eachWidth || eachWidth}
        >
            {
                collapsible && collapsible.wrapInCollapsible ?
                    <Collapsible open={collapsible.collapsibleIsOpen} label={formObj.label}>
                        {renderController()}
                    </Collapsible> : renderController()
            }
        </Grid>
    )
}

export const VideoController = ({
    formObj = {},
    classes,
    control,
    eachWidth,
    fileType,
    collapsible = {
        wrapInCollapsible: false,
        collapsibleIsOpen: false
    },
    previewUrl = '',
    ...props
}) => {
    const [videoPreviewUrl, setVideoPreviewUrl] = React.useState(previewUrl)

    const renderController = () => (
        <Controller
            defaultValue={""}
            render={({ onChange, name, value }) => (
                <FileInput
                    fileType={fileType}
                    onChange={(e) => onChange(e.target.files)}
                    name={name}
                    buttonLabel={formObj.label}
                    previewUrl={
                        videoPreviewUrl && videoPreviewUrl.length > 0 ? videoPreviewUrl :
                            value && value.length > 0 && URL.createObjectURL(value[0])
                    }
                    onClick={(e) => {
                        onChange("");
                        e.target.value = null;
                        setVideoPreviewUrl(null)
                    }}
                    imageName={value && value.length > 0 && value[0].name}
                    accept={formObj.accept}
                    readOnly={formObj.disableAccept}
                />
            )}
            control={control}
            name={formObj.name}
        />
    )
    return (
        <Grid
            key={formObj.name}
            className={classes.gridItem}
            item
            xs={12}
            sm={formObj.eachWidth || eachWidth}
        >
            {
                collapsible && collapsible.wrapInCollapsible ?
                    <Collapsible open={collapsible.collapsibleIsOpen} label={formObj.label}>
                        {renderController()}
                    </Collapsible> : renderController()
            }
        </Grid>
    )
}

export const TypographyController = ({ key, classes, as, label, eachWidth, ...props }) => {
    return (
        <Grid
            key={key}
            className={classes.gridItem}
            item
            xs={12}
            sm={eachWidth}
            {...props}
        >
            <Typography variant={as}>{label}</Typography>
        </Grid>
    )
}

export const RadioController = ({ key, formObj, control, classes, eachWidth, ...props }) => {
    return (
        <Grid
            key={key}
            className={classes.gridItem}
            item
            xs={12}
            sm={eachWidth}
            {...props}
        >
            <Controller
                render={
                    ({ onChange, value, ref }) => {
                        return (
                            <RadioInput
                                label={formObj.validationRules && formObj.validationRules.required
                                    ? (formObj.label?.concat(" *")) : formObj.label}
                                handleChange={(e) => {
                                    !formObj.readOnly && onChange(
                                        e.target.value
                                    )
                                }}
                                value={value || formObj.selectedValue}
                                options={formObj.options}
                                disabledValues={formObj.disabledValues}
                                row={formObj.showOptionsHorizontally}
                                {...props}
                            />
                        )
                    }
                }
                control={control}
                name={formObj.name}
                defaultValue=''
                rules={{ ...formObj.validationRules }}
            />
            <ErrorMessage
                as={<Text ascent="error" component="small" variant="body2" />}
                name={formObj.name}
            />
        </Grid>
    )
}

export const MarkdownController = ({ formObj, classes, control, eachWidth, ...props }) => {
    return (
        <Grid
            key={formObj.name}
            className={classes.gridItem}
            item
            xs={12}
            sm={formObj.eachWidth || eachWidth}
        >
            <Controller
                render={
                    ({ onChange, value, ref }) => (
                        <MDEditor
                            value={value}
                            onChange={(val) => onChange(val)}
                            textareaProps={{
                                placeholder: formObj.validationRules && formObj.validationRules.required ? (formObj.label?.concat(" *")) : formObj.label,
                                name: formObj.name,
                                disabled: formObj.readOnly
                            }}
                        />
                    )
                }
                control={control}
                name={formObj.name}
                rules={{ ...formObj.validationRules }}
                defaultValue=''
            />
            <ErrorMessage
                as={<Text ascent="error" component="small" variant="body2" />}
                name={formObj.name}
            />
        </Grid>
    )
}